export const DEFERRED = 'Отложено';
export const DEFER = 'В избранное';
export const EVENT_CLICK = 'click';



// WEBPACK FOOTER //
// ./src/components/parts/catalog/card/components/defer/const.ts